import React, { useState, useRef, ReactNode } from 'react'
import { Icon } from 'layouts'
import { ParagraphLarge, ParagraphRegular } from 'layouts/typography'
import style from './Accordion.module.scss'

interface Props {
    children: ReactNode
    title: string
}

function Accordion(props: Props): JSX.Element {
    const [active, setActive] = useState(false)
    const [height, setHeight] = useState('0px')

    const content = useRef(null)

    function toggleAccordion(): void {
        setActive(!active)
        setHeight(active ? '0px' : `${content.current.scrollHeight}px`)
    }

    return (
        <div className={style.accordion}>
            <button
                onClick={toggleAccordion}
                className={style(style.inner, { [style.active]: active })}
                type="submit"
            >
                <ParagraphLarge>
                    {props.title}{' '}
                    <Icon
                        regular
                        name="chevron-double-down"
                        className={style.icon}
                    />
                </ParagraphLarge>
            </button>
            <div
                ref={content}
                className={style.content}
                style={{ maxHeight: height }}
            >
                <ParagraphRegular>{props.children}</ParagraphRegular>
            </div>
        </div>
    )
}

export default Accordion
